import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../store/store';
import { updateSearch } from '../../store/apiPageReducer';
import searchImg from '../../img/search.png';
import './_header.scss';
import './_nav.scss';

type HeaderProps = {
  onSearch?: (value: string) => void;
};

export default function Header(props: HeaderProps) {
  const state = useAppSelector((state) => state.apiPage);
  const dispatch = useAppDispatch();

  const handleChange = (e: React.SyntheticEvent) => {
    const { value } = e.target as HTMLInputElement;
    dispatch(updateSearch(value));
  };

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { onSearch } = props;
    let search = state.search;
    if (search === undefined) search = '';
    if (onSearch) {
      onSearch(search);
    }
  };

  const search = state.search;
  const { onSearch } = props;
  const isSearchPage = onSearch !== undefined;

  return (
    <header className="header">
      <div className="wrapper header__wrapper">
        <NavLink to="/" className="nav__link home" title="home">
          <h1 className="logo">React.Components</h1>
        </NavLink>
        <div className="search">
          {isSearchPage && (
            <form className="search__form" onSubmit={handleSearch}>
              <input
                onInput={handleChange}
                value={search}
                autoFocus
                type="search"
                placeholder="Search..."
                className="search__input"
                autoComplete="off"
              />
              <button className="search__button" type="submit">
                <img src={searchImg} alt="search-img" />
              </button>
            </form>
          )}
        </div>
        <nav className="nav">
          <ul className="nav__list">
            <li className="nav__item">
              <NavLink to="/" className="nav__link home" title="home">
                <span className="nav__link-text">Homepage</span>
              </NavLink>
            </li>
            <li className="nav__item">
              <NavLink to="/about" className="nav__link" title="about">
                <span className="nav__link-text">About us</span>
              </NavLink>
            </li>
            <li className="nav__item">
              <NavLink to="/forms" className="nav__link" title="about">
                <span className="nav__link-text">Forms</span>
              </NavLink>
            </li>
          </ul>
        </nav>
        <div className="hamburger" id="hamburger-1">
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </header>
  );
}
